import { Component, Inject, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from '../../services/context/data.service';
import { RefDataService } from '../../services/context/ref-data.service';
import { Utils } from '../../../utils/utils';
import * as fromModel from '../../services/models';
import { Constant } from '../../../environments/constants';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { ReferenceService } from '../../services/reference/reference.service';

@Component({
  selector: 'gp-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.scss']
})
export class EditClientComponent implements OnInit {

  form: FormGroup;

  mode = "edit";
  roleDesc = "Client";
  role = fromModel.CLIENTROLE.Primary;
  clientid = "";
  clientname;
  validationMsg='';
  age = 0;
  states: fromModel.CodeValue[] = [];
  empTypes: fromModel.CodeValue[] = [];
  client;
  searchClient;

  constructor(  
    private dataService: DataService,
    private refDataService: RefDataService,
    private referenceService: ReferenceService,
    private readonly fb: FormBuilder,
    private dialogRef: MatDialogRef<EditClientComponent>,
    private dialog: MatDialog, 
    @Inject(MAT_DIALOG_DATA) private inputData: any) { 

      this.form = this.fb.group({
          dateOfBirth: ['', [Validators.required]],
          gender: ['', [Validators.required]],
          state: ['', [Validators.required]],
          empType: ['', [Validators.required]],
          // empIncome: [{ value: '', disabled: true }, [Validators.maxLength(10)]]
        }    
      );

    }

  ngOnInit(): void {
    this.mode = this.inputData.mode;
    this.clientid = this.inputData.clientid;
    if(this.inputData.searchClient){
      this.searchClient = this.inputData.searchClient;
      this.clientname = this.searchClient.clientname;
    }
    if(this.inputData.role && this.inputData.role === fromModel.CLIENTROLE.Secondary){
      this.role = this.inputData.role;
      this.roleDesc = "Spouse";
    } else {
      this.roleDesc = "Client";      
    }
    
    this.referenceService.getStatesRefrenceData().subscribe(statesRef =>{
      let _states = <fromModel.CodeValue[]>statesRef;
      _states.forEach(state => {
        this.states.push(state);
      });      
    });

    this.empTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.EmploymentTypes);

    this.setFormValues();
  }

  setFormValues(){

    if(this.mode === "add"){
      this.client = this.dataService.getClientByClientId(this.clientid); //load client from Clients node
      if(this.client){
        this.clientname = this.client.clientname;
        this.age = this.client.age;
        this.form.setValue({
          dateOfBirth: this.client.dob,
          gender: '',
          state: '',
          empType: '',
          //empIncome: '',        
        });
      } else if(this.searchClient) {
        this.age = this.searchClient.age;        
        this.form.setValue({
          dateOfBirth: this.searchClient.dob,
          gender: '',
          state: '',
          empType: '',
          //empIncome: '',        
        });
      }
    } else {
      this.client = this.dataService.getPlanClientByClientId(this.clientid); //load client from Plan object (PlanClient) node
      if(this.client){
        this.clientname = this.client.clientname;
        if(this.client.dob){
          this.age = this.client.age;
        }
        this.form.setValue({
          dateOfBirth: this.client.dob,
          gender: this.client.gender,
          state: this.client.stateOfResi,
          empType: this.client.empType,
          //empIncome: this.client.salary,        
        });

        // if(this.client.empType==='RET' || this.client.empType==='NOW'){
        //   this.form.get('empIncome').disable();
        //   this.clearValidators('empIncome');
        // } else {        
        //   this.form.get('empIncome').enable();
        //   this.setValidators("empIncome",[Validators.required, Validators.maxLength(10)]);      
        // }
      }
    }
    
  }

  removeSpouse(){
    
  }

  saveClient(){
  
    if(this.mode === "add"){
      let planClient: fromModel.PlanClient = {
        clientid: this.clientid,
        clientname: this.clientname,
        role: fromModel.CLIENTROLE.Secondary,
        dob: this.form.get('dateOfBirth').value,
        age: this.age,
        retAge: fromModel.DEFAULTS.retAge,
        gender: this.form.get('gender').value,
        stateOfResi: this.form.get('state').value,
        empType: this.form.get('empType').value,
        //salary: this.form.get('empIncome').value,
        initials: this.dataService.getClientInitials(this.clientname),
        endAge: this.refDataService.getLifeExpectancyForClient(this.age, this.form.get('gender').value, fromModel.HEALTHCONDITION.Average, fromModel.SMOKER.N).endAge        
      }
      this.dataService.dispatchAction(fromModel.DATA_ACTION.UPDATECLIENT, "EditClientComponent-saveClient", {planClient: planClient});      
      this.dataService.dispatchAction(fromModel.DATA_ACTION.ACCOUNTS, "EditClientComponent-saveClient", null);
      this.dataService.savePlan();    
      this.dataService.setClientInContext();
    } else {
      this.client.dob = this.form.get('dateOfBirth').value;
      this.client.age = this.age;      
      this.client.gender = this.form.get('gender').value;
      this.client.stateOfResi = this.form.get('state').value;
      this.client.empType = this.form.get('empType').value;
      //this.client.salary = this.form.get('empIncome').value;
      this.dataService.dispatchAction(fromModel.DATA_ACTION.UPDATECLIENT, "EditClientComponent-saveClient", {planClient: this.client});
      this.dataService.savePlan();      
    } 
    this.closeDialog(true);
  }

  dobChangeEvent(event: MatDatepickerInputEvent<Date>) {    
    this.age = Utils.calculateAge(event.value);
  }


  selectEmpType(event: any, value: string){
    if(event.isUserInput){
      
        // if(value==='RET' || value==='NOW'){
        //   this.form.get('empIncome').setValue('');        
        //   this.form.get('empIncome').disable();
        //   this.clearValidators('empIncome');
        // } else {        
        //   this.form.get('empIncome').setValue(''); 
        //   this.form.get('empIncome').enable();
        //   this.setValidators("empIncome",[Validators.required, Validators.maxLength(10)]);      
        // }        
    }
  }


  prepareEmploymentIncome(incomeType: fromModel.INCOMETYPE, client: fromModel.PlanClient){
    let income: fromModel.Income = null;
    let incDesc  = `${this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Incomes, incomeType).value} Income`;
    let isMonthly = false;
    
    income = { 
      "incId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMINC),
      "incType": incomeType,
      "incDesc":incDesc,
      "owner": client.clientid,
      "growthType": fromModel.GROWTHTYPE.INF,
      "amtPeriod": [
        {
          "startType": fromModel.AMOUNTPERIODTYPE.Year,
          "startYr": new Date().getFullYear(),
          "amount": client.salary,
          "endType": fromModel.AMOUNTPERIODTYPE.AtRet          
        }
      ],
      isMonthly: isMonthly,      
      isTaxable: true,
      isAdjToFutureDollar: true,
      isIncluded: true
    };   
    
    return income;
  }

  setValidators(field, validators: ValidatorFn[]){
    this.form.controls[field].setValidators(validators);
    this.form.controls[field].updateValueAndValidity();
  }

  clearValidators(field){
    this.form.controls[field].setErrors(null);    
    this.form.controls[field].clearValidators();
    this.form.controls[field].updateValueAndValidity();
  }

  closeDialog(saved: boolean | false): void {
    //this.dialogRef.close({isSaved: saved, income: this.income});
    this.dialogRef.close({isSaved: saved});    
  }

}
